
import { Component, Vue } from '~/utility/pu-class-decorator'
import { isLocalStorageAvailable } from '~/utility/isLocalStorageAvailable'

@Component
export default class LowResultsBounds extends Vue {
  get modifyFilters() {
    return {
      area: this.previousNonBoundsSearch?.area,
      bounds: undefined,
      hierarchyPath: this.previousNonBoundsSearch?.previousPath,
      placename: this.previousNonBoundsSearch?.placename,
    }
  }

  get previousNonBoundsSearch() {
    if (isLocalStorageAvailable()) {
      const storedPreviousSearch = localStorage.getItem('maps-previous-search')
      return storedPreviousSearch ? JSON.parse(storedPreviousSearch) : undefined
    } else {
      return undefined
    }
  }
}
